import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import {
  checkIsNoResultToolOutput,
  type NoResultToolOutput,
} from "@repo/app-types/agents/noResultToolOutput";
import type {
  ComparePlaybookNodeProposalToolInput,
  ComparePlaybookNodeProposalToolOutput,
} from "@repo/app-types/entities/configurationAgent";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const ComparePlaybookNodeProposalTool: ToolComponent<
  ComparePlaybookNodeProposalToolInput,
  | ComparePlaybookNodeProposalToolOutput
  | MastraErrorToolOutput
  | NoResultToolOutput
> = (props) => {
  if (props.status.type === "running") {
    return (
      <ChatToolBase status={props.status}>
        Testing playbook proposal
      </ChatToolBase>
    );
  }

  // An expected condition (criterion/section not found, no validation
  // interactions, ...) — surface the feedback as a completed, not failed, tool
  // call.
  if (checkIsNoResultToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>{props.output.message}</ChatToolBase>
    );
  }

  if (checkIsMastraErrorToolOutput(props.output)) {
    return (
      <ChatToolBase status={props.status}>
        An error occurred while testing the playbook proposal
      </ChatToolBase>
    );
  }

  if (props.status.type === "complete" && props.output) {
    const interactionCount =
      props.output.evaluated_interactions.length.toLocaleString();

    return (
      <ChatToolBase status={props.status}>
        Tested playbook changes on {interactionCount} interaction
        {props.output.evaluated_interactions.length === 1 ? "" : "s"}
      </ChatToolBase>
    );
  }

  return (
    <ChatToolBase status={props.status}>
      Testing playbook changes...
    </ChatToolBase>
  );
};
